import React, { useEffect } from "react";
import _ from "lodash";
import OrderStatus from "../../components/OrderStatus";
import { showOrderStatus } from "../../redux/actions";
import { useAppDispatch } from "../../redux/hook";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import {
  useResponsive,
  useResponsiveMaterial,
} from "../../hooks/useResponsive";
import { TopAccountBar } from "../../components/InfoBar/components/TopAccountBar/TopAccountBar.view";
import styles from './OrderTracking.styles'
export const OrderTracking = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  useResponsive();
  const chargeId = location.state?.chargeId;
  const isMobile = useResponsiveMaterial("md", "down");
  useEffect(() => {
    if (chargeId) {
      dispatch(showOrderStatus(chargeId));
    }
  }, [chargeId, dispatch]);
  return (
    <Box sx={styles.container}>
      <Box sx={styles.topBar}>
        <TopAccountBar isOrderTracking={true} />
      </Box>
      <Box sx={styles.content}>
        <OrderStatus chargeId={chargeId} isMobile={isMobile} />
      </Box>
    </Box>
  );
};
